export class Dot {
  root: HTMLLIElement
  private anchor: HTMLAnchorElement

  constructor(index: number, private className: string, clicked: (index: number) => void) {
    this.root = document.createElement("li")
    this.root.classList.add(`${className}__dots-item`)

    this.anchor = document.createElement("a")
    this.anchor.classList.add(`${className}__dot`)
    this.anchor.href = "#"
    this.anchor.appendChild(document.createTextNode(String(index)))

    this.root.appendChild(this.anchor)
    this.root.addEventListener("click", (event) => {
      event.preventDefault()
      clicked(index)
    })
  }

  setVisible(visible: boolean) {
    this.anchor.classList.toggle(`${this.className}__dot--active`, visible)
  }
}
